<template>
    <v-card class="card"
      :id="item.id"
      :to="{path: '/events/' + item.id, query: $store.getters.filtersQuery}"
      width="100%"
      height="100%"
      shaped
      tile
    >
        <v-layout row wrap ma-0 pa-0 fill-height>
          <v-flex v-if="breakpoint >= 1024"
            :xs2="breakpoint === 1024"
            :xs3="breakpoint >= 1680"
            class="subheading type time"
          >
            <span v-if="item.te">{{[item.ts] | moment('DD/MM', '–')}}</span><br/>
            <span v-if="item.ts && item.te">
              {{[item.ts, item.te] | moment('HH:mm', '–')}}
            </span>
          </v-flex>

          <v-flex class="pt0 pl-3 pb-3 pr-3"
            :xs12="breakpoint === 375 || breakpoint === 1024"
            :xs9="breakpoint >= 1680"
            :style="{
              borderLeft: `4px solid ${getEventColor(item, 'type').color}`
            }"
          >
            <v-flex xs12 sm12 class="typeText pt0">
              <div style="display: table">
                <div style="display: table-row">
                  <div class="type"
                    :style="{
                      backgroundColor: getEventColor(item, 'type').color,
                      color: getEventColor(item, 'type').text
                    }"
                  >
                  {{ item.type }}
                  </div>
                  <div class="icons" v-if="showFavorites">
                    <v-btn fab flat small
                      @click.stop.prevent="eventFavorites(item)"
                      :color="item.favorites ? 'red' : 'primary'"
                      :aria-label="item.favorites ? 'Убрать из закладок' : 'Добавить в закладки'"
                    >
                      <font-awesome-icon :icon="['far', 'heart']" />
                    </v-btn>
                  </div>
                </div>
              </div>
            </v-flex>
            <v-flex xs12>
              <v-flex xs12 v-if="breakpoint === 375"
                class="subheading pt-4"
              >
                <span v-if="item.te">{{[item.ts] | moment('DD/MM', '–')}}</span><br/>
                <span v-if="item.ts && item.te">
                  {{[item.ts, item.te] | moment('HH:mm', '–')}}
                </span>
              </v-flex>
              <v-flex xs12 class="title font-weight-light pt-4 pb-4">
                {{item.title}} <br />
                <span v-if="item.genre.length > 0"
                      class="body-1 font-weight-light font-italic">
                  {{item.genre}}
                </span>
              </v-flex>
            </v-flex>
            <v-flex xs11>
              <div v-show="item.zone">{{item.zone}}</div>
              <div v-show="item.hall">Площадка {{item.hall}}</div>
            </v-flex>
          </v-flex>
        </v-layout>
    </v-card>
</template>

<script>
/* eslint-disable no-param-reassign */
import { mapState } from 'vuex';

export default {
  name: 'EventCard',
  props: {
    item: {
      type: Object,
      require: true,
    },
    index: Number,
    to: Object,
  },
  data() {
    return {
      showFavorites: false,
      show: true,
    };
  },
  computed: {
    ...mapState(['breakpoint', 'favorites']),
  },
  methods: {
    eventFavorites(item) {
      const self = this;
      this.$nextTick(() => {
        const index = self.favorites.indexOf(item.id);
        if (index === -1) {
          self.favorites.push(item.id);
          item.favorites = true;
        } else {
          self.favorites.splice(index, 1);
          item.favorites = false;
        }
      });
    },
    getEventColor(event, key) {
      let bColor = '#aaaaaa';
      try {
        bColor = event.colors[key] || '#aaaaaa';
      } catch (e) {
      }
      return {
        color: bColor,
        text: this.wc_hex_is_light(bColor) ? '#000000' : '#ffffff',
      };
    },
    close() {
      this.$router.go(-1);
    },
    wc_hex_is_light(color) {
      const hex = color.replace('#', '');
      const cR = parseInt(hex.substr(0, 2), 16);
      const cG = parseInt(hex.substr(2, 2), 16);
      const cB = parseInt(hex.substr(4, 2), 16);
      const brightness = ((cR * 299) + (cG * 587) + (cB * 114)) / 1000;
      return brightness > 155;
    },
  },
};
</script>

<style lang="scss" scoped>
  .v-card {
    height: 100% !important;
  }
  .pt0 { padding-top: 0px !important; }
  .type {
    display: table-cell;
    padding: 6px !important;
    min-width: 20%;
  }
  .icons {
    display: table-cell;
    padding: 0px !important;
  }
  .icons button {
    padding: 2px !important;
    margin: 2px !important;
  }
  .title {
    white-space: pre-line;
  }
  .time {
    white-space: nowrap;
  }
</style>
